(function () {
    'use strict';

    angular
        .module('app')
        .controller('CampaignEditController', CampaignEditController);

    CampaignEditController.$inject = ['debug', '$stateParams', 'API', 'i18n', 'helpers', 'alert', 'ListViewSearchExtension', 'campaignCategory', '$state', 'config',];

    function CampaignEditController(debug, $stateParams, API, i18n, helpers, alert, ListViewSearchExtension, campaignCategory, $state, config) {
        var vm = this;
        vm.id = $stateParams.id;
        ListViewSearchExtension.extendScope(vm);
        vm.listObject.filter = {
            active: '',
            sort: 'latestFirst',
        };
        vm.id = $stateParams.id;
        vm.isSaving = false;
        vm.save = save;
        vm.campaign = {};
        vm.loadingState = {
            campaignIsLoading: false,
            campaignCodesAreLoading: false,
            subscriptionPlans: false,
        };
        vm.campaignCategories = {};
        vm.subscriptionPlans = [];

        vm.loadResources = loadCampaignCodes;

        vm.openAddCampaignCodeModal = openAddCampaignCodeModal;
        vm.openRemoveModal = openRemoveModal;
        vm.campaignCodes = [];
        vm.newlyAddedCodes = [];
        vm.campaignMeta = {};
        vm.loginUrlEn = config.get('loginSiteEN');
        vm.loginUrlSv = config.get('loginSiteSV');

        activate();

        function activate() {
            angular.forEach(campaignCategory.get(), function (value, key) {
                value.then(function (response) {
                    vm.campaignCategories[key] = response;
                }, function () {
                });
            });
            if ($stateParams.searchObject) {
                vm.loadParams(JSON.parse($stateParams.searchObject));
            }
            loadCampaign();
            loadSubscriptionPlans();
        }

        function openRemoveModal() {
            var promise = alert.confirm('remove-item');

            promise.then(function () {
                var removePromise = API.Campaign.recycle({ id: vm.id }).$promise;

                removePromise.then(function () {
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('CAMPAIGN_RECYCLED') });
                    $state.go('campaigns.list');
                }, function () {
                });
            }, function () {
            });
        }

        function loadCampaign() {
            vm.loadingState.campaignIsLoading = true;
            API.Campaign.get({
                id: vm.id,
            }).$promise.then(function (response) {
                vm.campaign = response;
                if (response.campaign_meta) {
                    vm.campaignMeta = JSON.parse(response.campaign_meta);
                }
                loadCampaignCodes();

                vm.loadingState.campaignIsLoading = false;
            }, function (response) {
                debug.log(response);
            });
        }

        function loadCampaignCodes() {

            var searchObject = {
                'fk_campaign_id': vm.id,
                'page': vm.listObject.page,
                'per-page': vm.listObject.perPage,
            };

            if (vm.listObject.filter.active) {
                searchObject.active = vm.listObject.filter.active;
            }

            if (vm.listObject.filter.sort) {
                switch (vm.listObject.filter.sort) {
                    case 'latestFirst':
                        searchObject.sort = '-created_at';
                        break;
                    case 'oldestFirst':
                        searchObject.sort = 'created_at';
                        break;
                    case 'alphabetAscending':
                        searchObject.sort = '-code';
                        break;
                    case 'alphabetDescending':
                        searchObject.sort = 'code';
                        break;

                    default:
                        break;
                }
            }

            if (vm.listObject.searchTerm && vm.listObject.searchTerm.length > 1) {
                searchObject.q = vm.listObject.searchTerm;
            }

            var promise = API.CampaignCode.search(searchObject).$promise;

            vm.onSearch();

            if (promise) {
                vm.loadingState.campaignCodesAreLoading = true;
                promise.then(function (response) {
                    vm.campaignCodes = response.items;
                    vm.listMeta = response._meta;
                }, function (response) {
                    debug.log(response);
                })
                    .finally(function () {
                        vm.loadingState.campaignCodesAreLoading = false;
                    });

            }
        }

        function loadSubscriptionPlans() {
            vm.loadingState.subscriptionPlans = true;
            API.SubscriptionPlan.search({ provider: 'Stripe' }).$promise.then(function (response) {
                angular.extend(vm.subscriptionPlans, response.items);

                vm.loadingState.subscriptionPlans = false;
            }, function () {
            });
        }

        function openAddCampaignCodeModal() {
            var promise = alert.prompt('add-campaign-code', { campaign: vm.campaign });
            promise.then(function (response) {
                vm.newlyAddedCodes.push(response);
            }, function () {
                debug.log('User closed prompt.');
            });
        }

        function save() {
            if (!vm.isSaving) {
                vm.isSaving = true;

                var logoRegex = /(brand-logos).*/;
                if (logoRegex.test(vm.campaign.brand_logo)) {
                    var logoPath = vm.campaign.brand_logo.match(logoRegex);
                    vm.campaign.brand_logo = logoPath[0];
                }
                vm.campaign.campaign_meta = JSON.stringify(vm.campaignMeta);

                var promise = vm.campaign.$save();
                promise.then(function () {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                }, function (response) {
                    debug.log(response);
                })
                    .finally(function () {
                        vm.isSaving = false;
                    });
            }
        }
    }
})();